import { Services } from '@sigma-frontend-libs/commons'
import { isUUID } from '@sigmasms/commons'

import { billingsSources, proxy, toNumberOrUndefined } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    currency: String
  },

  computed: {
    canGenerateBillings() {
      return this.checkPermissions(`advanced.${Services.billings}.generate`)
    },

    ownerIdsDisabled() {
      if (this.canGenerateBillings) {
        return []
      }

      return [ this.account.id ]
    },

    validation() {
      const amount = parseFloat(this.proxy.amount)
      if (isNaN(amount) || amount <= 0) {
        return false
      }
      if (!Object.values(billingsSources).includes(this.proxy.source)) {
        return false
      }
      if (!isUUID(this.proxy.OwnerId)) {
        return false
      }
      if (!this.proxy.data.multiplier) {
        return false
      }

      return true
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    }
  },

  mounted() {
    if (this.$route.name === Services.billings) {
      if (toNumberOrUndefined(this.proxy.amount) === 0) {
        this.proxy.amount = undefined
      }
    }

    this.$emit('validation', this.validation)
  },

  render
}
